import { useSession } from '../Context';
import UserMenuExtension from '@/UserMenuExtension';

import EditableName from './EditableName';
import EditablePassword from './EditablePassword';

const UserMenu = ({ children, visible, hideMenu }) => {
  const {
    document: { user },
    close,
  } = useSession();

  return (
    <>
      {/* BACKDROP */}
      {visible && (
        <div
          className='fixed inset-0 bg-black/50 backdrop-blur-xs z-800'
          onClick={hideMenu}
        />
      )}

      {/* DRAWER PANEL */}
      <div
        className={`fixed right-0 top-0 h-full w-80 bg-base-200 shadow-xl z-900
        transform transition-transform duration-300
        flex flex-col
        ${visible ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className='p-4 flex justify-between items-center border-b'>
          <div className='email'>
            {user.email.match(/@/) ? '' : '@'}
            {user.email}
          </div>
          <button
            className='btn btn-ghost btn-sm btn-circle'
            onClick={hideMenu}
          >
            X
          </button>
        </div>

        <div className='bg-base-200 text-base-content flex w-80 flex-col flex-grow p-4'>
          <EditableName />
          <EditablePassword />
          <UserMenuExtension />
          <div className='flex-grow' />
          <button
            className='btn btn-primary'
            onClick={() => close()}
          >
            Déconnexion
          </button>
        </div>
      </div>
    </>
  );
};

export default UserMenu;
